class PropagationManager {
	constructor() {
		this.origins = null;
	}

	init () {
		this.origins = [];
	}

	addOrigin(payload) {
		if (!payload || !payload.url) {
			return console.error('Must have origin url!');
		}
		this.origins.push(payload);
	}

	get inited () {
		return !!this.origins;
	}

	propegateEvent(data) {
		if (!this.inited) {
			return;
		}

		if (!this.origins.length) {
			return console.warn("No origin to propegate data to!");
		}
		try {
			this.origins.forEach((origin) => {
				const windowObject = origin.windowObject || window;
				if (!windowObject.parent) {
					console.warn('no parent found')
					return;
				}
				windowObject.parent.postMessage(data, origin.url)
			});
		} catch (error) {
			// console.error(error)
		}
	}
}

export default new PropagationManager();
